import { makeAutoObservable, runInAction } from "mobx";
import agent from "../services/Api/agent";
import { LocationGroup, LocationGroupForm, LocationGroupDto } from "../models/LocationGroup";

export default class LocationGroupStore {
    loadingInitial = false;
    submitting = false;

    LocationGroups: LocationGroupDto[] = [];
    selectedLocationGroup: LocationGroupDto | undefined = undefined;
    filterPlaceholder = "Filter Location Groups";

    constructor() {
        makeAutoObservable(this);
    }

    ChangePlaceHolder = (p: string) => {
        this.filterPlaceholder = p;
    }

    LoadingLocationGroups = async () => {
        this.loadingInitial = true;
        try {
            const locationGroups = await agent.LocationGroups.list();
            runInAction(() => {
                this.LocationGroups = locationGroups ? locationGroups : [];
            });
        } catch (error) {
            throw error;
        }
        this.loadingInitial = false;
    }

    LoadSelectedLocationGroup = async (id: string) => {
        const Id: number = Number(id);
        let newLocationGroup: LocationGroupDto | undefined = this.LocationGroups.find((element) => element.id === Id);
        if (newLocationGroup) {
            runInAction(() => this.selectedLocationGroup = newLocationGroup);
        } else {
            this.loadingInitial = true;
            try {
                newLocationGroup = await agent.LocationGroups.details(Id);
                runInAction(() => this.selectedLocationGroup = newLocationGroup);
                this.loadingInitial = false;
            } catch (error) {
                throw error;
            }
            this.loadingInitial = false;
        }
        return this.selectedLocationGroup;
    }

    CreateLocationGroup = async (record: LocationGroup) => {
        this.submitting = true;
        try {
            await agent.LocationGroups.create(record);
        } catch (error) {
            throw error;
        }
        this.submitting = false;
    }

    EditLocationGroup = async (record: LocationGroup) => {
        this.submitting = true;
        try {
            await agent.LocationGroups.update(record);
        } catch (error) {
            throw error;
        }
        this.submitting = false;
    }

    // EditLocationGroup = async (record: LocationGroup) => {
    //     console.log(record);
    //     this.submitting = true;
    //     try {
    //         await agent.LocationGroups.update(record);
    //     } catch (error) {
    //         this.submitting = false;
    //         throw error;
    //     }
    //     this.submitting = false;
    // }

    // LoadSelectedLocationGroup = async (id: string) => {
    //     const Id: number = Number(id);
    //     let newLocationGroup: LocationGroup | undefined = this.LocationGroups.find((element) => element.id === Id);
    //     if (newLocationGroup) {
    //         runInAction(() => this.selectedLocationGroup = newLocationGroup);
    //     } else {
    //         this.loadingInitial = true;
    //         try {
    //             newLocationGroup = await agent.LocationGroups.details(id);
    //             runInAction(() => this.selectedLocationGroup = newLocationGroup);
    //             this.loadingInitial = false;
    //         } catch (error) {
    //             throw error;
    //         }
    //         this.loadingInitial = false;
    //     }
    //     return this.selectedLocationGroup;
    // }

    getLocationGroupHistory = async (id?: string) => {
        // TODO: Implement when backend API is available
        // if (id == null) return;
        // return await agent.LocationGroups.getHistory(id);
        return undefined;
    }

    clearSelectedLocationGroup = () => {
        this.selectedLocationGroup = undefined;
    }
}

